export default __webpack_public_path__ + "static/media/pb20.85049028.png";